import React from 'react';
import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import SearchOrders from '../components/SearchOrders/SearchOrders';
import TestimonialSubmit from '../components/Testimonial/testimonialSubmit';
import { UserInformation } from '../context/appContext';
export default function RouterProject() {
 return (

   <BrowserRouter>
    <Routes>
     <Route index path="/" exact={true} element={<SearchOrders />} />
     <Route path="*" exact={true} element={<SearchOrders />} />
     <Route path="/pages/wedding-contest/search" exact={true} element={<SearchOrders />} />
     <Route
      path="/pages/wedding-contest/testimonial"
      exact={true}
      element={<TestimonialSubmit />}
     />
    </Routes>
   </BrowserRouter>
 );
}
